module.exports = __webpack_public_path__ + "img/mobileculture1.bf90176f.png";